import { useState } from 'react';

import { BodyText, HorizontalContainer } from '@american-autonomy/rantizo-ui';
import { CloseButton } from '@mantine/core';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const BaseNotification: FunctionComponent<Props> = ({
    children,
    className = '',
    onClose,
    testId = TEST_ID,
    text
}) => {
    const [isClosed, setIsClosed] = useState(false);

    return (
        <HorizontalContainer
            className={`${className} ${isClosed ? styles.closed : styles.baseNotificationContainer}`}
            testId={testId}
        >
            <HorizontalContainer className={styles.iconTextContainer}>
                <div className={styles.iconContainer}>{children}</div>

                <BodyText className={styles.notificationText} text={text} />
            </HorizontalContainer>

            <CloseButton
                onClick={() => {
                    onClose?.();
                    setIsClosed(true);
                }}
                className={styles.closeButton}
            />
        </HorizontalContainer>
    );
};

export default BaseNotification;
